import React from 'react';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { FileText } from 'lucide-react';

export function replaceMergeFields(text, lead, user) {
  if (!text) return text;
  return text
    .replace(/\{\{lead_name\}\}/g, lead?.name || lead?.first_name || '')
    .replace(/\{\{lead_email\}\}/g, lead?.email || '')
    .replace(/\{\{lead_phone\}\}/g, lead?.phone || '')
    .replace(/\{\{lead_company\}\}/g, lead?.company || '')
    .replace(/\{\{lead_status\}\}/g, lead?.status || '')
    .replace(/\{\{my_name\}\}/g, user?.name || '')
    .replace(/\{\{my_company\}\}/g, user?.company || '');
}

export function TemplateSelector({ templates, onApply }) {
  if (!templates || templates.length === 0) return null;

  return (
    <div>
      <Label className="text-[10px] font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wide flex items-center gap-1">
        <FileText className="w-3 h-3" /> Use Template
      </Label>
      <Select onValueChange={onApply}>
        <SelectTrigger className="mt-1 rounded-sm" data-testid="email-template-select">
          <SelectValue placeholder="Select a template..." />
        </SelectTrigger>
        <SelectContent>
          {templates.map(t => (
            <SelectItem key={t.id} value={t.id}>{t.name}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
